<app-config-editor
 *ngIf="!!otherConfig && !!draftConfig && !!draftLessons"
  [translationConfig]=otherConfig 
  [lang]="lang" 
  [draftConfig]="draftConfig" 
  [draftLessons]="draftLessons"
  ></app-config-editor>